<template>
  <div
    class="ui-form-field ui-form-field--bool ui-form-field--checkbox"
    :class="[...rootClasses, bemAdd(isChecked ? 'is-checked' : '')]"
  >
    <label>
      <input
        type="checkbox"
        class="ui-form-field__input"
        :value="value"
        v-bind="$attrs"
        @change="onChange"
        v-on="$listeners"
      />
      <span class="ui-form-field__label-wrap">
        <span class="ui-form-field__box">
          <slot
            name="icon"
            :is-checked="isChecked"
            :icon-classes="['ui-form-field__box-icon']"
            :icon-classes-base="['ui-form-field__box-icon', 'ui-form-field__box-icon--base']"
            :icon-classes-checked="['ui-form-field__box-icon', 'ui-form-field__box-icon--checked']"
          >
            <span class="ui-form-field__box-icon" />
          </slot>
        </span>
        <span v-if="$scopedSlots.label" class="ui-form-field__label">
          <slot name="label" />
        </span>
      </span>
    </label>
    <slot name="messages" />
  </div>
</template>

<script>
  import bemMixin from '@/assets/js/mixin/bem'
  import rootClassesMixin from '@/assets/js/mixin/root-classes'
  import isCheckedMixin from '@/assets/js/mixin/is-checked'
  import hasErrorsPropsMixin from '@/assets/js/mixin/has-error-props'

  export default {
    mixins: [bemMixin('ui-form-field'), rootClassesMixin, isCheckedMixin, hasErrorsPropsMixin],
    props: {
      value: {
        type: [Boolean, Number, String],
        default: false,
      },
    },
  }
</script>
